<template>
  <div class="content">
    <navigator title="请选择退单原因"></navigator>
    <van-panel title="退单原因" desc="" class="cancel top">
      <van-radio-group v-model="radio1">
        <van-cell-group>
          <van-cell title="地址错误" clickable @click="radio1 = '1';remark ='地址错误'">
            <van-radio name="1" />
          </van-cell>
          <van-cell title="不在岗，需同班人员处理" clickable @click="radio1 = '2';remark ='不在岗，需同班人员处理'">
            <van-radio name="2" />
          </van-cell>
          <van-cell title="待处理工单太多，需同班人员处理" clickable @click="radio1 = '3';remark ='待处理工单太多，需同班人员处理'">
            <van-radio name="3" />
          </van-cell>
          <van-cell title="报修分类错误，需转电工类" clickable @click="radio1 = '4';remark ='报修分类错误，需转电工类'">
            <van-radio name="4" />
          </van-cell>
          <van-cell title="报修分类错误，需转排水类" clickable @click="radio1 = '5';remark ='报修分类错误，需转排水类'">
            <van-radio name="5" />
          </van-cell>
          <van-cell title="报修分类错误，需转土建类" clickable @click="radio1 = '6';remark ='报修分类错误，需转土建类'">
            <van-radio name="6" />
          </van-cell>
          <van-cell title="报修分类错误，需转空调类" clickable @click="radio1 = '7';remark ='报修分类错误，需转空调类'">
            <van-radio name="7" />
          </van-cell>
          <van-cell title="其他" clickable @click="radio1 = '0';remark =''">
            <van-radio name="0" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-panel>
    <van-cell-group>
      <van-field required v-model="remark" class="top" placeholder="请输入备注说明" v-show="radio1 == '0'"/>
      <van-button class="btn" type="danger" @click="onSubmit" v-if="remark !== ''">提 &nbsp;交</van-button>
      <van-button class="btn" type="danger" @click="onSubmit" disabled v-else>提 &nbsp;交</van-button>
    </van-cell-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return {
      message: '',
      radio1: '1',
      remark: '地址错误',
      orderId: 0,
    }
  },
  created () {
    this.orderId = this.$route.params.orderId
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
  methods: {
    onSubmit(){
      this.$http.post(`${this.URL_PREFIX}/app/refund/maintain/order/personnel`,{
        orderId: this.orderId,
        remark: this.remark
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        Toast(res.resDesc);
      }).then(()=>{
        this.$router.push({ path:`/repairer/apply/${this.orderId}`})
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.content{
  background: #efefef;
  .top{
    margin-top: 8px;
  }
  .btn{
    margin-left: 10%;
    width: 80%;
    margin-top: 38px;
    background: #d9262c;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/repairer/RepairerClose.vue